import classNames from 'classnames';
import * as PropTypes from 'prop-types';
import React from 'react';
import { t } from '../../lang';
import HelperService from '../../services/HelperService';
import TypesService from '../../services/TypesService';
import Icon, { Icons } from '../Icon/Icon';
import './AMLFundsRiskItem.scss';

const CurrenciesById = TypesService.CurrenciesById;

const riskColor = {
	Low: 'var(--AML-low)',
	Medium: 'var(--AML-medium)',
	High: 'var(--AML-high)',
	Outdated: 'var(--AML-outdated)',
	Unverified: 'var(--AML-outdated)',
};

const AMLFundsRiskItem = ({ percent = null, isActualAML = true, currencyId, checkDate, type = 'source' }) => {
	const currencyData = CurrenciesById[currencyId];
	const blockchain = HelperService.getBlockchainNameByCurrencySymbol(currencyData?.Name);
	const { risk } = HelperService.getAmlRiskByText(percent, isActualAML, blockchain, false, checkDate);

	return (
		<div
			className={classNames('AMLFundsRiskItem', risk, type)}
			style={{ '--hight': `${percent || 0}%`, '--color': riskColor[risk] }}
		>
			<div className='AMLFundsRiskItem__content'>
				<div className='AMLFundsRiskItem__text'>
					<Icon type={Icons.ARROW_CIRCLE_FILL} width={16} height={16} />
					{type === 'source' ? t('Source of funds Avg. risk (%)') : t('Use of funds Avg. risk (%)')}
				</div>
				<div className='AMLFundsRiskItem__percent'>{percent || 0}%</div>
			</div>

			<div className='AMLFundsRiskItem__progress'>
				<div className='AMLFundsRiskItem__progress-line'>
					<div className='AMLFundsRiskItem__progress-circle'></div>
				</div>
			</div>
		</div>
	);
};

AMLFundsRiskItem.propTypes = {
	percent: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf([null])]),
	isActualAML: PropTypes.bool,
	currencyId: PropTypes.number.isRequired,
	type: PropTypes.oneOf(['source', 'use']),
};

export default AMLFundsRiskItem;
